import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
    getManagementUserById,
    getManagementUsers,
    getManagementUsersList,
    ManagementUsersListParams,
    ManagementUsersParams,
} from '../clients/gateway.api';
import { getUser } from '../clients/user.api';
import { getOnboardingUser } from '../clients/userOnboard.api';

interface MemberQuickFilterTotalsParams {
    searchQuery?: string;
    companyIds?: string[];
    groupIds?: string[];
    filterKey: string;
}

export const members = createQueryKeys('members', {
    currentUser: {
        queryKey: null,
        queryFn: () => getUser(),
    },
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getManagementUserById(id),
    }),
    pagination: (params: ManagementUsersParams) => ({
        queryKey: [{ params }],
        queryFn: () => getManagementUsers(params),
    }),
    list: (params: ManagementUsersListParams) => ({
        queryKey: [{ params }],
        queryFn: () => getManagementUsersList(params),
    }),
    comboBoxOptions: (params: ManagementUsersListParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOption: (memberId: string) => ({
        queryKey: [memberId],
    }),
    totals: (params: MemberQuickFilterTotalsParams) => ({
        queryKey: [{ params }],
    }),
    onboarding: (id: string, token: string) => ({
        queryKey: [id, token],
        queryFn: () => getOnboardingUser(id, token),
    }),
});
